import { lazy } from 'react';

export const ReportPage = lazy(() => import('@/views/pages/Reports'));
export const P2WReportsPage = lazy(() => import('@/views/pages/P2WReports'));
export const TopupReportPage = lazy(() => import('@/views/pages/TopupReport'));
export const TopUpGamesPage = lazy(
  () => import('@/views/pages/Business/TopUpGames')
);
export const TransactionAllPage = lazy(
  () => import('@/views/pages/Staff/TransactionAll')
);
export const TopupTransactionsPage = lazy(
  () => import('@/views/pages/Staff/TransactionAll/TopupTransactions')
);
export const CustomerCreditTransactionsPage = lazy(
  () => import('@/views/pages/Staff/CustomerCreditTransactions')
);
export const GameListPage = lazy(() => import('@/views/pages/Staff/GameList'));
export const GameListCreatePage = lazy(
  () => import('@/views/pages/Staff/GameList/Create')
);
export const GameListEditPage = lazy(
  () => import('@/views/pages/Staff/GameList/Edit')
);
export const GameListViewPage = lazy(
  () => import('@/views/pages/Staff/GameList/View')
);
export const PackagePage = lazy(() => import('@/views/pages/Staff/Package'));
export const CreatePackagePage = lazy(
  () => import('@/views/pages/Staff/Package/Create')
);
export const EditPackagePage = lazy(
  () => import('@/views/pages/Staff/Package/Edit')
);
export const PackageHistoryPage = lazy(
  () => import('@/views/pages/Staff/Package/History')
);
export const ImportPackagePage = lazy(
  () => import('@/views/pages/Staff/Package/Import')
);
export const CreateSerialPage = lazy(
  () => import('@/views/pages/Staff/Package/Serial/Create')
);
export const ImportSerialPage = lazy(
  () => import('@/views/pages/Staff/Package/Serial/Import')
);
export const EditSerialPage = lazy(
  () => import('@/views/pages/Staff/Package/Serial/Edit')
);
export const LoginPage = lazy(() => import('@/views/pages/Login'));
export const MainPage = lazy(() => import('@/views/pages/Main'));
export const RegisterPage = lazy(() => import('@/views/pages/Register'));
export const TWOFAPage = lazy(() => import('@/views/pages/Login/TwoFA'));
export const Register2FAPage = lazy(
  () => import('@/views/pages/Login/Register2FA')
);
export const ChangePasswordPage = lazy(
  () => import('@/views/pages/Login/ChangePassword')
);
export const ForgotPasswordPage = lazy(
  () => import('@/views/pages/Login/ForgotPassword')
);
export const ConfirmResetPasswordPage = lazy(
  () => import('@/views/pages/Login/ConfirmResetPassword')
);
export const ProfilePage = lazy(() => import('@/views/pages/Profile'));
export const DistributorPage = lazy(
  () => import('@/views/pages/Staff/Distributor')
);
export const CreateDistributorPage = lazy(
  () => import('@/views/pages/Staff/Distributor/Create')
);
export const EditDistributorPage = lazy(
  () => import('@/views/pages/Staff/Distributor/Edit')
);
export const DiscountConfigurationPage = lazy(
  () => import('@/views/pages/Staff/Distributor/DiscountConfiguration')
);
export const PackageMarkupPage = lazy(
  () => import('@/views/pages/Staff/Distributor/PackageMarkup')
);
export const CreditWalletPage = lazy(
  () => import('@/views/pages/Staff/CreditWallet')
);
export const TopUpCreditPage = lazy(
  () => import('@/views/pages/Staff/CreditWallet/TopUpCredit')
);
export const AdjustCreditPage = lazy(
  () => import('@/views/pages/Staff/CreditWallet/AdjustCredit')
);
export const TopupCryptoPage = lazy(
  () => import('@/views/pages/Staff/CreditWallet/TopupCrypto')
);
export const LandingPageManagementPage = lazy(
  () => import('@/views/pages/Business/LandingPageManagement')
);
export const ManageAccountsPage = lazy(
  () => import('@/views/pages/ManageAccounts')
);
export const CreateAccountPage = lazy(
  () => import('@/views/pages/ManageAccounts/Create')
);
export const EditAccountPage = lazy(
  () => import('@/views/pages/ManageAccounts/Edit')
);
export const UserHistoryPage = lazy(
  () => import('@/views/pages/ManageAccounts/History')
);
export const ApproveRequestPage = lazy(
  () => import('@/views/pages/Staff/ApproveRequest')
);
export const ApproveHistoryPage = lazy(
  () => import('@/views/pages/Staff/ApproveHistory')
);
export const OnlineMonitorPage = lazy(
  () => import('@/views/pages/Staff/OnlineMonitor')
);
export const BotMonitorPage = lazy(
  () => import('@/views/pages/Staff/BotMonitor')
);
export const SupplierListPage = lazy(
  () => import('@/views/pages/Staff/SupplierList')
);
export const SupplierListCreatePage = lazy(
  () => import('@/views/pages/Staff/SupplierList/Create')
);
export const SupplierListEditPage = lazy(
  () => import('@/views/pages/Staff/SupplierList/Edit')
);
export const LineNotifyTargetsPage = lazy(
  () => import('@/views/pages/Staff/LineNotifyTargets')
);
export const SMSMonitorPage = lazy(
  () => import('@/views/pages/Staff/SMSMonitor')
);
export const BusinessSMSMonitorPage = lazy(
  () => import('@/views/pages/Business/SMSMonitor')
);
export const LineNotifyTargetsCreatePage = lazy(
  () => import('@/views/pages/Staff/LineNotifyTargets/Create')
);
export const LineNotifyTargetsEditPage = lazy(
  () => import('@/views/pages/Staff/LineNotifyTargets/Edit')
);
export const ManageCustomersPage = lazy(
  () => import('@/views/pages/Business/ManageCustomers')
);
export const ManageCustomerDetailPage = lazy(
  () => import('@/views/pages/Business/ManageCustomers/Detail')
);
export const CustomerDiscountPage = lazy(
  () => import('@/views/pages/Business/CustomerDiscount')
);
export const CustomerDiscountTierPage = lazy(
  () => import('@/views/pages/Business/CustomerDiscountTier')
);
export const CreateCustomerDiscountTierPage = lazy(
  () => import('@/views/pages/Business/CustomerDiscountTier/Create')
);
export const EditCustomerDiscountTierPage = lazy(
  () => import('@/views/pages/Business/CustomerDiscountTier/Edit')
);
export const BankManagementPage = lazy(
  () => import('@/views/pages/Business/BankAccountManagement')
);
export const CreateBankPage = lazy(
  () => import('@/views/pages/Business/BankAccountManagement/Create')
);
export const EditBankPage = lazy(
  () => import('@/views/pages/Business/BankAccountManagement/Edit')
);
export const CreditTransactionPage = lazy(
  () => import('@/views/pages/Business/CreditTopUpTransaction')
);
export const CreateCreditTopUpTransactionPage = lazy(
  () => import('@/views/pages/Business/CreditTopUpTransaction/Create')
);
export const AdjustCustomerCreditPage = lazy(
  () =>
    import('@/views/pages/Business/CreditTopUpTransaction/AdjustCustomerCredit')
);
export const SettingsPage = lazy(() => import('@/views/pages/Staff/Settings'));
export const BusinessSettingsPage = lazy(
  () => import('@/views/pages/Business/Settings')
);
export const GameAndPackagePage = lazy(
  () => import('@/views/pages/Business/GameAndPackage')
);
export const PackageByGameIDPage = lazy(
  () => import('@/views/pages/Business/GameAndPackage/PackageByGameID')
);
export const SortGamesPage = lazy(
  () => import('@/views/pages/Business/GameAndPackage/SortGames')
);
export const BusinessSortPackagesPage = lazy(
  () => import('@/views/pages/Business/GameAndPackage/SortPackages')
);
export const BusinessProfitReportPage = lazy(
  () => import('@/views/pages/Business/ProfitReport')
);
export const StaffProfitReportPage = lazy(
  () => import('@/views/pages/Staff/ProfitReport')
);
export const SortPackagesPage = lazy(
  () => import('@/views/pages/Staff/Package/SortPackages')
);
export const PartnerAPIKeyPage = lazy(
  () => import('@/views/pages/Business/PartnerAPIKey')
);
export const PartnerAPIKeyCreatePage = lazy(
  () => import('@/views/pages/Business/PartnerAPIKey/Create')
);
export const PartnerDocsPage = lazy(
  () => import('@/views/pages/PartnerDocs')
);
export const StorefrontTemplatePage = lazy(
  () => import('@/views/pages/Business/StorefrontTemplate')
);
export const StreamerManagementPage = lazy(
  () => import('@/views/pages/Business/StreamerManagement')
);
export const CreateStreamerPage = lazy(
  () => import('@/views/pages/Business/StreamerManagement/Create')
);
export const EditStreamerPage = lazy(
  () => import('@/views/pages/Business/StreamerManagement/Edit')
);
export const StreamerCommissionConfigPage = lazy(
  () => import('@/views/pages/Business/StreamerManagement/CommissionConfig')
);
export const StreamerReportPage = lazy(
  () => import('@/views/pages/Business/StreamerManagement/Report')
);
export const PendingReviewTopUpsPage = lazy(
  () => import('@/views/pages/Staff/CreditWallet/PendingReview')
);
export const GarenaReportsPage = lazy(
  () => import('@/views/pages/GarenaReports')
);
